import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-notification',
  templateUrl: './modal-notification.component.html',
  styleUrls: ['./modal-notification.component.scss']
})
export class ModalNotificationComponent implements OnInit {
  @ViewChild('content') content: any;
  @Input() title: string;
  @Input() text: string;
  @Input() buttonText: string;
  @Input() mainAction: string;
  @Input() includeDetail: boolean = false;
  @Output() mainActionClicked = new EventEmitter<{ action: string, detail: string }>();
  detailText: string = '';

  constructor(private modalService: NgbModal) { }

  ngOnInit(): void {
  }

  open(title?: string, text?: string, buttonText?: string, mainAction?: string) {
    this.title = title ? title : this.title;
    this.text = text ? text : this.text;
    this.buttonText = buttonText ? buttonText : this.buttonText;
    this.mainAction = mainAction;
    this.modalService.open(this.content, { ariaLabelledBy: 'modal-basic-title', scrollable: true });
  }

  onMainActionClicked() {
    this.mainActionClicked.emit({ action: this.mainAction, detail: this.detailText });
    this.dismiss();
  }

  dismiss() {
    this.modalService.dismissAll();
  }
}
